export default __webpack_public_path__ + "static/media/feature_1.6ea91ebb.png";